<template>
    <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M0.508491 8.41899C0.506618 8.13643 0.610149 7.86255 0.800348 7.64692C0.990547 7.4313 1.25485 7.28817 1.54543
               7.24343L1.72703 7.22906L15.6565 7.1149C15.9653 7.11482 16.2628 7.22617 16.4901 7.42686C16.7174 7.62755 16.8578
               7.90293 16.8836 8.19838C16.9093 8.49383 16.8185 8.78777 16.629 9.02192C16.4396 9.25608 16.1655 9.41333 15.861
               9.4625L15.6773 9.47757L1.74778 9.59037C1.42177 9.59249 1.10819 9.47035 0.875861 9.25075C0.643528 9.03114 0.511409
               8.73202 0.508491 8.41899Z"
        />
        <path
            d="M8.86022 16.8861C8.57769 16.8914 8.30261 16.7911 8.08474 16.6035C7.86687 16.4158 7.72061 16.1533 7.67242 15.8632L7.6559
               15.6818L7.37626 1.75466C7.37252 1.4459 7.48033 1.14707 7.6783 0.917423C7.87628 0.687773 8.14997 0.544081 8.44509 0.514839C8.74021
               0.485597 9.03522 0.572943 9.2716 0.759554C9.50799 0.946165 9.66849 1.21841 9.72127 1.52231L9.73852 1.70584L10.0168 15.633C10.0228
               15.959 9.90438 16.274 9.68755 16.5089C9.47072 16.7438 9.17318 16.8795 8.86022 16.8861Z"
        />
    </svg>
</template>

<script>
export default {
  name: 'IconRight',
};
</script>
